import { Box } from '@pets-ui/Box/Box'
import { HelpOutlined } from '@pets-ui/icons'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { Tooltip } from '@pets-ui/Tooltip/Tooltip'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Amount from '../../components/amount'
import { useAdminOrders } from '../../hooks/use-admin-orders'
import style from '../../style/components/order-total.module.scss'

const baseStyle = stylex.create({
  root: {
    padding: 12,
    gap: 12,
    backgroundColor: colors.white,
    width: '100%',
  },
})

export const AdminOrderTotal = () => {
  const { t } = useTranslation()
  const { exhibitorSettings } = useSelector((state: RootState) => state.clientContents)
  const isUS = exhibitorSettings?.currency === 'USD'
  const [showTooltip, setShowTooltip] = useState(false)

  const handleOpenTooltip = () => setShowTooltip(true)
  const handleCloseTooltip = () => setShowTooltip(false)

  const { destructuredData: orders } = useAdminOrders()
  const itemsAmount = orders?.subtotal
  const shippingFee = orders?.shipping_total
  const discountAmount = orders?.discount_total
  const tax = orders?.tax
  const total = orders?.total

  return (
    <VStack rootStyle={baseStyle.root}>
      <Text variant="h5">交易金額摘要</Text>
      {orders
        ? (
          <section className={style.wrapper}>
            <VStack gap={2}>
              <div className={style['footer-row']}>
                <Text variant="body">商品合計</Text>
                <span className={style['header-span']}>
                  <Amount amount={itemsAmount ?? 0} />
                </span>
              </div>
              <div className={style['footer-row']}>
                <Text variant="body">優惠合計</Text>
                <span className={style['footer-row-amount']}>
                  <Amount
                    amount={((discountAmount ?? 0) * -1)}
                  />
                </span>
              </div>
              <div className={style['footer-row']}>
                <Text variant="body">運費合計</Text>
                <span className={style['footer-row-amount']}>
                  <Amount
                    amount={shippingFee ?? 0}
                  />
                </span>
              </div>
              {isUS
              && (
                <div className={style['footer-row']}>
                  <span className={style['footer-row-title']}>
                    {t('discountPopup.salesTax')}
                    <Tooltip
                      open={showTooltip}
                      title={t('discountPopup.salesTaxTip')}
                      placement="top"
                    >
                      <Box
                        component="span"
                        ml={1}
                        onMouseEnter={handleOpenTooltip}
                        onMouseLeave={handleCloseTooltip}
                        onTouchStart={handleOpenTooltip}
                        onTouchEnd={handleCloseTooltip}
                      >
                        <HelpOutlined />
                      </Box>
                    </Tooltip>
                  </span>
                  <span className={style['footer-row-amount']}>
                    <Amount
                      amount={tax ?? 0}
                    />
                  </span>
                </div>
              )}
              <div className={style.line} />
              <div className={style['footer-row']}>
                <Text variant="subtitle">訂購總額</Text>
                <Text color={colors.red600} variant="h5">
                  <Amount
                    bold
                    amount={total ?? 0}
                  />
                </Text>
              </div>
            </VStack>
          </section>
        )
        : <Skeleton height="194px" variant="rounded" />}

    </VStack>
  )
}
